import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ChatFeature } from './chat.actions';
import { ChatState } from './chat.types';

export const selectChatState = createFeatureSelector<ChatState>(ChatFeature);

export const selectChatMessages = createSelector(
  selectChatState,
  state => state.messages,
);

export const selectIsDiscussionLoading = createSelector(
  selectChatState,
  state => state.isLoading,
);

export const selectResponseLoading = createSelector(
  selectChatState,
  state => state.isResponseLoading,
);

export const selectChatIsOpen = createSelector(
  selectChatState,
  state => state.isOpen,
);

export const selectChatError = createSelector(
  selectChatState,
  state => state.error,
);

export const selectRecentMessages = createSelector(
  selectChatMessages,
  messages => messages.slice(-20),
);
